import React from 'react';
import './style.css';
import HeroSection from './HeroSection';
import BenefitsSection from './BenefitsSection'
import PlansSection from './PlansSection'
import Net30Section from './Net30Section'
import NoWebsiteSection from './NoWebsiteSection'
import GuaranteeSection from './GuaranteeSection'
import CallToActionSection from './CallToActionSection'

export default function Hosting() {

  return (
    <React.Fragment>
      <HeroSection/>
      <BenefitsSection/>
      <PlansSection id="plans"/>
      <Net30Section id="net30"/>
      <NoWebsiteSection id="web-development"/>
      <GuaranteeSection id="guarantee"/>
      <CallToActionSection id="schedule-call"/>
    </React.Fragment>
  );
}
